module.exports = __webpack_public_path__ + "img/assignedTo-individual.81679263.svg";